import React from "react";
import { X } from "lucide-react";
import EnquiryForm from "@/components/EnquiryForm";

export default function EnquiryDialog({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="enquiry-dialog">
      <div className="absolute inset-0 bg-ink/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-2xl max-h-[90vh] overflow-y-auto bg-parchment border border-ink/20 shadow-2xl p-8 md:p-10">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-ink/55 hover:text-burgundy transition-colors"
          aria-label="Close"
          data-testid="enquiry-dialog-close"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="eyebrow">Correspondence</div>
        <h2 className="press-title text-3xl md:text-4xl text-ink mt-2 mb-7">Enquire</h2>
        <EnquiryForm onSuccess={onClose} />
      </div>
    </div>
  );
}
